export default __webpack_public_path__ + "static/media/36t.1dc9f94c.jpg";